import * as CONSTANTS from '../constants/constants';

const initialState = {
  loading: false,
  ppContent: {},
  ppContentSuccess: ''
};

const contents = (state = initialState, action) => {
  // console.log(action)
  switch (action.type) {
    case CONSTANTS.GET_PP:
      return Object.assign({}, state, {
        loading: false,
        ppContent: action.ppContent
      });
    case CONSTANTS.UPDATE_PP:
      return Object.assign({}, state, {
        loading: true,
        ppContentSuccess: ''
      });
    case CONSTANTS.UPDATE_PP_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        ppContentSuccess: CONSTANTS.UPDATE_PP_SUCCESS_MSG
      });
    default:
      return state;
  }
};

export default contents;
